/**
 * @fileoverview GET handler for the "/engagement/message_steps_for_uco/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementMessageStepsForUcoCanvasId } from "./constants";
import type { EngagementMessageStepsForUcoCanvasIdResult } from "./types";
import { isEngagementMessageStepsForUcoCanvasIdResult } from "./validators";

export const getEngagementMessageStepsForUcoCanvasId = reactQueryFetcherAdapter(
  engagementMessageStepsForUcoCanvasId,
  (signal: AbortSignal, canvasId: string): Promise<EngagementMessageStepsForUcoCanvasIdResult> => {
    return fetch(`/engagement/message_steps_for_uco/${canvasId}`, "GET", {}, { signal });
  },
  isEngagementMessageStepsForUcoCanvasIdResult
);
